module.exports = __webpack_public_path__ + "img/desc.3af1a6ba.png";